<template>
  <form>
    <v-row>
      <v-col cols="12">
        <v-row>
          <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
            <v-subheader>Employee Name</v-subheader>
          </v-col>
          <v-col cols="8" sm="8" md="4" lg="4" class="py-0">
            <span>{{ form.employeeName }}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
            <v-subheader>Department</v-subheader>
          </v-col>
          <v-col cols="8" sm="8" md="4" lg="4" class="py-0">
            <span>{{ form.departmentName }}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
            <v-subheader>Amount <span class="red--text">*</span></v-subheader>
          </v-col>
          <v-col cols="8" sm="8" md="4" lg="4" class="py-0">
            <v-text-field
              v-model.number="form.amount"
              :error-messages="amountErrors"
              required
              outlined
              dense
              flat
              type="number"
              background-color="white"
              @input="$v.form.amount.$touch()"
              @blur="$v.form.amount.$touch()"
              ref="amount"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
            <v-subheader>Threshold <span class="red--text">*</span></v-subheader>
          </v-col>
          <v-col cols="8" sm="8" md="4" lg="4" class="py-0">
            <v-text-field
              v-model.number="form.threshold"
              :error-messages="thresholdErrors"
              required
              outlined
              dense
              flat
              type="number"
              background-color="white"
              @input="$v.form.threshold.$touch()"
              @blur="$v.form.threshold.$touch()"
              ref="threshold"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </form>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minValue } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],

  validations: {
    form: {
      amount: { required, minValue: minValue(0) },
      threshold: { required, minValue: minValue(0) },
    },
  },

  props: {
    form: Object,
  },

  computed: {
    amountErrors() {
      const errors = [];
      if (!this.$v.form.amount.$dirty) return errors;
      !this.$v.form.amount.required && errors.push("Amount is required");
      !this.$v.form.amount.minValue && errors.push("Amount must be greater than or equal to 0");
      return errors;
    },
    thresholdErrors() {
      const errors = [];
      if (!this.$v.form.threshold.$dirty) return errors;
      !this.$v.form.threshold.required && errors.push("Threshold is required");
      !this.$v.form.threshold.minValue &&
        errors.push("Threshold must be greater than or equal to 0");
      return errors;
    },
  },

  methods: {
    update() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        for (let key in Object.keys(this.$v.form)) {
          const input = Object.keys(this.$v.form)[key];
          if (input.includes("$")) return false;
          if (this.$v.form[input].$error) {
            this.$refs[input].focus();
            break;
          }
        }
      } else {
        this.$store.dispatch("employeeAllowance/update", this.form);
      }
    },
  },
};
</script>

<style></style>
